import React, { useMemo } from 'react';

import Link from 'next/link';

import { IconButton } from '@mui/material';

export type IconLinkProps = React.ComponentProps<typeof IconButton> & {
  href: string;
};

export const IconLink = ({ href, children, ...otherProps }: IconLinkProps) => {
  const memoizedLink = useMemo(
    () =>
      // eslint-disable-next-line react/no-unstable-nested-components
      React.forwardRef((props, ref: any) => (
        <Link ref={ref} href={href} {...props} />
      )),
    [href],
  );
  return (
    <IconButton
      component={memoizedLink as any}
      role="link"
      {...otherProps}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {children}
    </IconButton>
  );
};
